import Vue from 'vue';
import VueCountryCode from 'vue-country-code';

Vue.use(VueCountryCode);
